export default "__VITE_ASSET__B5Ncou8x__"